// src/components/Layout.js
import React, { useEffect, useRef } from "react"; // Import useRef to control animation
import { Link } from "react-router-dom";

const Layout = ({ children }) => {
  return (
    <div>
      {children}
      <div
        className="d-none d-md-flex flex-column"
        style={{
          position: "fixed",
          top: "30vh",
          right: "0",
          // padding: "10px",
          // borderTopLeftRadius: "20px",
          // borderBottomLeftRadius: "20px",
          // border: "2px solid #ccc", // Border for the first two buttons
          // borderRight: "none", // No right border to attach it to the edge
          // backgroundColor: "#f9f9f9", // Slight background color for visibility
          // display: "flex",
          // flexDirection: "column",
          // gap: "10px",
          // alignItems: "center",
          // zIndex: 99999,
        }}
      >
        <div
          className=""
          style={{
            padding: "10px",
            borderTopLeftRadius: "20px",
            borderBottomLeftRadius: "20px",
            border: "2px solid #AF9763", // Border for the first two buttons
            borderRight: "none", // No right border to attach it to the edge
            backgroundColor: "#f9f9f9", // Slight background color for visibility
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: "center",
            zIndex: 99999,
          }}
        >
          {/* First Button */}
          <a href="tel:10666">
            <button
              style={{
                width: "72px",
                height: "72px",
                borderRadius: "50%", // Rounded button
                border: "none",
                padding: 0,
                backgroundColor: "transparent",
                cursor: "pointer",
              }}
            >
              <img
                src="/assets/images/call_update.svg"
                alt="Call"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            </button>
          </a>

          {/* Second Button */}
          <Link to={"/pages/emergency"}>
            <button
              style={{
                width: "72px",
                height: "72px",
                borderRadius: "50%", // Rounded button
                border: "none",
                padding: 0,
                backgroundColor: "transparent",
                cursor: "pointer",
              }}
            >
              <img
                src="/assets/images/emargency_update.svg"
                alt="Emergency"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            </button>
          </Link>
        </div>
        <div className="" style={{ padding: "10px", zIndex: 99999 }}>
          {/* Third Button outside the border, below the first two */}
          <button
            className="d-none d-md-flex"
            style={{
              width: "72px",
              height: "72px",
              borderRadius: "50%", // Rounded button
              border: "none",
              padding: 0,
              backgroundColor: "transparent",
              cursor: "pointer",
              animation: "shakeButton 1s ease-in-out infinite",
            }}
          >
            <img
              src="/assets/images/jci-gold-seal 1.png"
              alt="Gold Seal"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
          </button>
        </div>
      </div>

      {/* CSS Animation */}
      <style jsx>{`
        @keyframes shakeButton {
          0% {
            transform: translateX(0); /* No movement */
          }
          25% {
            transform: translateX(-10px); /* Move left */
          }
          50% {
            transform: translateX(10px); /* Move right */
          }
          75% {
            transform: translateX(-10px); /* Move left again */
          }
          100% {
            transform: translateX(0); /* Return to original position */
          }
        }
      `}</style>
    </div>
  );
};

export default Layout;



// WEBPACK FOOTER //
// ./src/component/Layout.js